/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-vars */
/* eslint-disable */
import Divider from "components/Divider";
import Button from "components/Button";
import H1 from "components/H1";
import H4 from "components/H4";
import H5 from "components/H5";
import ImageProfile from "components/ImageProfile";
import TextInput from "components/TextInput";
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Svg from "_assets/svg";
import Toast from "components/Toast";
import authSvc from "services/authSvc";
import { isEmail } from "utils/regexExp";
// import { useDispatch } from "react-redux";
// import { logout } from "_redux/actions/authAction";
import userSvc from "services/userSvc";
import { getInitial, stringToHslColor } from "utils/helpers";

import './editProfile.scss'
import ButtonOutline from "components/ButtonOutline";

const HR = styled.hr`
  width: 520px;
  height: 1px;

  background: #d8dce1;
`;

const IMG = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 7px;
`;

const INPUT = styled(TextInput)`
  width: ${(props) => (props.full ? `520px` : `250px`)};
  height: 48px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const ButtonUpload = styled.div`
  margin-left: 15px;
`;

const IconUpload = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 7px;
`;

const DefaultAva = styled.div`
  height: 70px;
  width: 70px;
  border-radius: 50%;
  background-color: #06b676;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
`;

const UploadAva = ({ fullName, avatar, handleUpload }) => {
  const uploadRef = useRef();
  return (
    <div className="margin-top-20">
      <FlexRow>
        {!avatar?.view ? (
          <DefaultAva>{fullName ? fullName?.split("")[0].toUpperCase() : "N/A"}</DefaultAva>
        ) : (
          <ImageProfile src={avatar.view} size="70" />
        )}
        <ButtonUpload>
          <input
            ref={uploadRef}
            type="file"
            id="upload-button"
            style={{ display: "none" }}
            onChange={handleUpload}
          />
          <Button handleRoute={() => uploadRef.current?.click()}>
            {" "}
            <IconUpload src={Svg.download_v2.default} />
            Upload
          </Button>
        </ButtonUpload>
      </FlexRow>
    </div>
  );
};

const EditProfilePage = () => {
  const history = useHistory();
  // const dispatch = useDispatch();
  const initialValidation = {
    fullName: { isValid: true, msg: "" },
    email: { isValid: true, msg: "" },
  };
  const [form, setForm] = useState();
  const [validation, setValidation] = useState();
  const [isLoading, setLoading] = useState(false);
  const [toastData, setToastData] = useState({});
  const [toastVisible, setToastVisible] = useState(false);

  useEffect(async () => {
    const currentUser = authSvc.currentUser();
    if (!form) {
      const newForm = {
        id: currentUser?.user.id,
        fullName: currentUser?.user.fullName ?? "",
        email: currentUser?.user.email ?? "",
        phoneNumber: currentUser?.user.phoneNumber ?? "",
        avatar: { view: currentUser?.user.avatar ?? "", raw: "" },
      };
      setForm(newForm);
      setValidation(initialValidation);
    }
  }, []);

  // eslint-disable-next-line no-unused-vars
  const onSubmit = () => {
    const isValid = validateForm();
    if (!isValid) {
      return;
    }

    setLoading(true);
    onUpdateUser();
  };

  const validateForm = () => {
    let validationForm = initialValidation;
    const { fullName, email } = form;
    if (!fullName) {
      validationForm = {
        ...validationForm,
        fullName: { ...validationForm.fullName, isValid: false, msg: "Fullname is required" },
      };
    }

    setValidation(validationForm);

    let result = true;
    Object.entries(validationForm).forEach(([, { isValid }]) => {
      if (!isValid) result = false;
    });
    return result;
  };

  const onUpdateUser = async () => {
    try {
      const { id, fullName, email, phoneNumber, avatar } = form;
      let fileUpload;
      if (avatar.raw) {
        fileUpload = await userSvc.upload(avatar.raw);
      }

      let dataFileUpload;
      if (avatar.raw) {
        dataFileUpload = fileUpload?.data?.data?.url
      }

      await userSvc.update(id, {
        fullName,
        avatar: dataFileUpload
      }).then(res => {
        console.log('res', res)
      });
      setToastData({
        description: "Your User data has been succesfully changed, please re-login"
      });
      setToastVisible(true);
      // setTimeout(() => {
      setLoading(false);
      //   // dispatch(logout());
      //   // history.replace("/auth/login");
      window.location.reload()
      // }, 5000);
    } catch (err) {
      setToastVisible(true);
      setToastData({ description: err.message });
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex flex-column" style={{padding: '25px 50px'}}>
        <div className="col-7">
          <div className="margin-bottom-10">
            <H1>Account Settings</H1>
          </div>
          <H4>Tell us who you are! You can modify your personal information here.</H4>
        </div>
        <Divider style={{ marginBlock: 15, marginInline: 0 }} />
        <div className="margin-bottom-5">
          <h4 className="fsize-14 fweight-600 cl-grey-black mb-0">Profile Photo</h4>
        </div>
        <div className="d-flex flex-row align-items-center margin-bottom-20">
          {/* <UploadAva
            fullName={form?.fullName}
            avatar={form?.avatar}
            value={form?.avatar.raw}
            handleUpload={(e) =>
              setForm({
                ...form,
                avatar: {
                  view: URL.createObjectURL(e.target.files[0]),
                  raw: e.target.files[0],
                },
              })
            }
          /> */}
          {form?.fullName ? 
          <span 
            className="initial_profile flex items-center font-semibold justify-center rounded-full text-xs lg:text-xs" 
            style={{
              color: stringToHslColor(getInitial(typeof form?.fullName !== "undefined"
                  ? form?.fullName
                  : "U"), 38, 50),
              background: stringToHslColor(getInitial(typeof form?.fullName !== "undefined"
                  ? form?.fullName
                  : "U"), 38, 80)
            }}>{getInitial(typeof form?.fullName !== "undefined"
              ? form?.fullName
              : "UNKNOWN")}
          </span> :
            <span 
            className="initial_profile flex items-center font-semibold justify-center rounded-full text-xs lg:text-xs" 
            style={{
              color: stringToHslColor(getInitial(typeof form?.email !== "undefined"
                  ? form?.email
                  : "U"), 38, 50),
              background: stringToHslColor(getInitial(typeof form?.email !== "undefined"
                  ? form?.email
                  : "U"), 38, 80)
            }}>{getInitial(typeof form?.email !== "undefined"
              ? form?.email
              : "UNKNOWN")}
          </span>
          }
        </div>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column margin-bottom-20">
            <INPUT
              full
              title="Fullname"
              value={form?.fullName}
              onChange={(event) => setForm({ ...form, fullName: event.target.value })}
              invalidFeedback={validation?.fullName?.msg}
            />
          </div>
          <div className="d-flex flex-column margin-bottom-20">
            <INPUT full title="Email address" value={form?.email} disabled={true} />
          </div>
          <div className="d-flex flex-column margin-bottom-20">
            <INPUT full title="Telephone" value={form?.phoneNumber} disabled={true} />
          </div>
          <div className="margin-bottom-10">
            <Button loading={isLoading} handleRoute={onSubmit} primary>
              Save Changes
            </Button>
          </div>
          <div className="margin-bottom-20">
            <ButtonOutline loading={isLoading} handleRoute={()=>history.push("/profile/change-password")} secondary textColor="#E81255">
              Change Password
            </ButtonOutline>
          </div>
          <Toast
            setIsVisible={(val) => setToastVisible(val)}
            isVisible={toastVisible}
            description={toastData.description}
            undo={toastData.undo}
          />
        </div>
      </div>
    </>
  );
};

export default EditProfilePage;
